<div class="c-cms-form" sk-field="{{field.fieldName}}">
    <div class="form-flex">
        <div class="form-label">{{if field.required == 1}}<span class="form-required">*</span>{{/if}}{{field.displayName}}</div>
        <div class="form-value">
            <div class="form-row">
                <div class="c-form-file">

                    <div class="file-upload" skf-if="!$field.value">
                        <div class="file-area">
                            <div class="file-text">点击添加图片</div>
                            <div class="file-tips">文件大小限制：5M</div>
                        </div>
                        <input type="file" class="file-input" title=""
                               skf-change="$parent.changeFile('{{field.fieldName}}')"
                               skf-accept="$field.accept"
                               skf-value="$field.value ? '' : null">
                    </div>

                    <div class="file-img" skf-if="$field.value">
                        <img skf-src="$field.value ? $field.value.newPath: ''" />
                        <div class="file-clear-img" skf-click="$parent.clearFile('{{field.fieldName}}')"></div>
                    </div>

                </div>
            </div>

            <div class="form-row form-error" skf-if="$field.dirty && $field.invalid" skf-text="$field.validationMessage"></div>

        </div>
    </div>
</div>